import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { FloatingWhatsApp } from "react-floating-whatsapp";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/style.scss";
import "./assets/css/materialdesignicons.min.css";

import ProtectedRoute from "./components/ProtectedRoute";
import logo from "./assets/images/logo.png";

const Home = lazy(() => import("./pages/home"));
const Projects = lazy(() => import("./pages/projects"));
const Faqs = lazy(() => import("./pages/faqs"));
const ContactUs = lazy(() => import("./pages/contactus"));
const AuthLogin = lazy(() => import("./pages/auth/auth-login"));
const AdminDashboard = lazy(() => import("./pages/admin/AdminDashboard"));
const Error = lazy(() => import("./pages/Special/error"));

function App() {
    return (
        <>
            <Suspense fallback={null}>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/faqs" element={<Faqs />} />
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route path="/auth-login" element={<AuthLogin />} />
                    <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                    <Route path="/error" element={<Error />} />
                    <Route path="*" element={<Error />} />
                </Routes>
            </Suspense>
            <FloatingWhatsApp
                phoneNumber="15146092300"
                accountName="Deo Réno"
                chatMessage="Bonjour! Comment pouvons-nous vous aider ?"
                statusMessage="Répond généralement en 1 heure."
                avatar={logo}
                allowEsc={true}
                allowClickAway={true}
                notification={true}
            />
        </>
    );
}

export default App;
